import script from "./AuthLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthLayout.vue?vue&type=script&setup=true&lang=ts"

import "./AuthLayout.vue?vue&type=style&index=0&id=c67912c2&lang=scss"

const __exports__ = script;

export default __exports__